console.log('🚀 [main.jsx] Start ładowania aplikacji');

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/main-dark.css'
import './styles/forms.css';

console.log('✅ [main.jsx] Wszystkie importy załadowane pomyślnie');
console.log('📦 [main.jsx] React:', React);
console.log('📦 [main.jsx] ReactDOM:', ReactDOM);
console.log('📦 [main.jsx] App:', App);

const rootElement = document.getElementById('root');
console.log('🎯 [main.jsx] Root element:', rootElement);

if (!rootElement) {
  console.error('❌ [main.jsx] Nie znaleziono elementu #root!');
  throw new Error('Root element not found');
}

console.log('🔧 [main.jsx] Tworzenie React root...');
const root = ReactDOM.createRoot(rootElement);
console.log('✅ [main.jsx] React root utworzony:', root);

console.log('🎨 [main.jsx] Renderowanie aplikacji...');
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
console.log('✅ [main.jsx] Aplikacja wyrenderowana!');
console.log('🎉 [main.jsx] Inicjalizacja zakończona pomyślnie!');
